import * as React from "react";
import EditorialBase from "../../EditorialBase";
import { ContentProps, EditorialFactoryProps } from "components/flexComponents/Editorial/typings";
import IconSectionEditorial from "./IconSectionEditorial";
import CardComparisonSection from "./CardComparisonSection";
import CitiTripleDipSectionEditorial from "./Citi/CititripledipSectionEditorial";
import CitiDesktopStickyBar from "./Citi/CitiDesktopStickybar";
import CitifaqSectionEditorial from "./Citi/CitiFaqSectionEditorial";
import CitiRewardsWithoutCompSectionEditorial from "./Citi/CitiRewardsWithoutCompSectionEditorial";
import CitiCalculatorSectionEditorial from "./Citi/CitiCalculatorSectionEditorial";
import HeroImageEditorial from "./Citi/HeroImageEditorial";
import CitiCardModalDialog from "components/flexComponents/Editorial/factory/impl/editorials/Citi/CitiCardModalDialog";
import CitiContent from "./Citi/CitiContent";

export class Grid3 extends EditorialBase {
  constructor(editorial: EditorialFactoryProps) {
    super(editorial);
  }

  public generate(props: ContentProps) {
    const { context, routeStore } = props;
    const { title, items } = this.editorial;
    const stickyBarText = "Sticky_bar";
    const RwcSection = "Citi_Rwc_Section";
    const iconSectionTitle = "icon_section";
    const cardComparisonSection = "Citi_Card_comparision";
    const calculatorSectionTitle = "Citi_Calculator_Section";
    const heroImage = "hero_image";
    const cardModalDialog = "Card_modal_dialog";
    const citiContent = "Citi_Content";

    return (
      <>
        {title.includes("triple_dip_section") && <CitiTripleDipSectionEditorial {...this.editorial} />}

        {title.includes(stickyBarText) && <CitiDesktopStickyBar items={items} />}

        {title.includes("Citi_Faq_Section") && <CitifaqSectionEditorial {...this.editorial} />}

        {title.includes(RwcSection) && (
          <CitiRewardsWithoutCompSectionEditorial model={this.editorial} context={context} />
        )}

        {title.includes(iconSectionTitle) && <IconSectionEditorial items={items} />}

        {title.includes(cardComparisonSection) && <CardComparisonSection {...this.editorial} />}

        {title.includes(calculatorSectionTitle) && <CitiCalculatorSectionEditorial {...this.editorial} />}

        {title.includes(heroImage) && <HeroImageEditorial items={items} />}

        {title.includes(cardModalDialog) && <CitiCardModalDialog routeStore={routeStore} items={items} />}

        {title.includes(citiContent) && <CitiContent items={items} />}
      </>
    );
  }
}

export default Grid3;
